module.exports = __webpack_public_path__ + "static/waterproof-mattress-protector-2-5b223ff79e09f1ddad2284c2fb419a15.png";